import React from "react";
import { FaInbox } from "react-icons/fa";
import ReceptionSearch from "./components/search";
import NewDocument from "./components/wedocument";
import CardDetail from "./components/cardDetail";
import GetCardCodes from "./api/GetCardCodes";
import GetCountriesData from "./api/GetCountriesData";

import { Fragment } from "react";
import Unpacking from "./components/unpacking";

class Reception extends React.Component {
  timer = null;
  state = {
    RFID: {
      data: sessionStorage.getItem("RFID")
        ? sessionStorage.getItem("RFID")
        : "",
      open: false,
    },
    prepare: localStorage.getItem("type_reception")
      ? localStorage.getItem("type_reception")
      : false,
    hideShip: false,
    hideCard: false,
    ship: null,
    scanWebOpen: false,
    scanFile: [],
    mobileFile: [],
    newDoc: false,
    existDoc: {
      open: false,
      data: null,
      idx: -1,
    },
    cardCodes: [],
    commChanel: [
      { value: 1, label: "E-mail" },
      { value: 3, label: "Mobil" },
    ],
    countriesData: [],
    card: {
      CurrCode: null,
      CardCodes: null,
      CardCode: null,
      CardName: null,
      CardICO: null,
      CardDIC: null,
      CntctCode: null,
      CntctName: null,
      CntctTel1: null,
      CntctCellolar: null,
      CntctEmail: null,
      PaySameShip: false,
      PayToCode: null,
      PayToStreet: null,
      PayToCity: null,
      PayToZipCode: null,
      PayToCountry: null,
      PayToWorplace: null,
      ShipToCode: null,
      ShipToStreet: null,
      ShipToCity: null,
      ShipToZipCode: null,
      ShipToCountry: null,
      ShipToAddrOnLine: null,
      ShipToWorkplace: null,
      CommChannel: null,
      RetTranspCode: null,
    },
    shipsData: [],
    docs: [],
    cardsdata: false,
    cardDetail: false,
    cardSetDetail: false,
    apidata: [],
  };

  loadCountries = async () => {
    var _res = await GetCountriesData({ ...this.props });
    if (_res.status === 200) {
      this.setState({
        countriesData: _res.data,
      });
    }
  };

  handleSearch = (query) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      if (!this.state.cardsdata) {
        this.setState({ cardsdata: true });
        var _res = await GetCardCodes({ ...this.props, query: query });
        if (_res.status === 200) {
          var decryptedCard = JSON.parse(this.props._decrypt(_res.data));
          this.setState({
            cardsdata: false,
            cardCodes: decryptedCard,
          });
          this.loadCountries();
        } else {
          this.setState({ cardsdata: false, cardCodes: [] });
        }
      }
    }, 200);
  };

  loadCardCodes = async (e) => {
    if (e.label < 3) return;
    this.setState({ cardsdata: true });
  };

  apiDataResolver = async (e) => {
    this.setState({ apidata: e, card: { ...this.state.card, ...e } });
    if (e.length > 0) {
      if (e[0].api_name === "TMBHIRR") {
        var _res = await GetCardCodes({ ...this.props, query: "Z0180" });
        if (_res.status === 200) {
          if (_res.data.length > 0) {
            this.setState({
              card: {
                ...this.state.card,
                ...JSON.parse(this.props._decrypt(_res.data))[0],
              },
            });
          }
        }
        this.setState({
          cardDetail: true,
        });
      }
    }
  };

  fullreset() {
    this.cardReset();
    this.setState({
      shipsData: [],
      docs: [],
      hideShip: false,
      hideCard: false,
      cardsdata: false,
      cardDetail: false,
      apidata: [],
      ship: null,
      scanFile: [],
      mobileFile: [],
      newDoc: false,
      existDoc: {
        open: false,
        data: null,
        idx: -1,
      },
      cardCodes: [],
      commChanel: [
        { value: 1, label: "E-mail" },
        { value: 3, label: "Mobil" },
      ],
      countriesData: [],
    });
  }

  cardReset = () => {
    this.setState({
      card: {
        CardCodes: null,
        CardCode: null,
        CardName: null,
        CardICO: null,
        CardDIC: null,
        CntctCode: null,
        CntctName: null,
        CntctTel1: null,
        CntctCellolar: null,
        CntctFax: null,
        CntctEmail: null,
        PaySameShip: false,
        PayToCode: null,
        PayToStreet: null,
        PayToCity: null,
        PayToZipCode: null,
        PayToCountry: null,
        ShipToCode: null,
        ShipToStreet: null,
        ShipToCity: null,
        ShipToZipCode: null,
        ShipToCountry: null,
        ShipToAddrOnLine: null,
        CommChannel: null,
        RetTranspCode: null,
      },
      cardSetDetail: false,
      hideShip: false,
      hideCard: false,
    });
  };

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FaInbox className="c-placeholder c-green" />,
      Title: "Příjem zásilek",
      SubTitle:
        "Začni tím, že si naskenuješ štítek dopravy a vyplníš pole 'Číslo zásilky', pak už stačí zmačnout enter nebo pokud používáš čtečku tak se to potvrdí samo.",
    });
    if (!sessionStorage.getItem("RFID")) {
      this.setState({
        RFID: {
          ...this.state.RFID,
          open: true,
        },
      });
    } else {
      this.setState({
        RFID: {
          ...this.state.RFID,
          data: sessionStorage.getItem("RFID"),
        },
      });
    }
    this.loadCountries();
    localStorage.setItem(
      "webCam",
      JSON.stringify({
        height: 900,
        width: 1440,
      })
    );
  }

  usedApiData = (e) => {
    let actualApiData = this.state.apidata;
    actualApiData.splice(e, 1);
    this.setState({ apidata: actualApiData });
  };

  render() {
    const { Bs, VARIANT, SIZE, Icon } = this.props;
    return (
      <>
        {this.state.RFID.open && (
          <Bs
            modal
            show={this.state.RFID.open}
            keyboard={false}
            backdrop="static"
            centered
            size={SIZE.SMALL}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Bs modalheader>
              <Bs row>
                <Bs col xs={12}>
                  <Bs span>Přihlaš se pomocí RFID </Bs>
                </Bs>
                <Bs col xs={12}>
                  <Bs small className="text-muted">
                    Toto je pouze provizorní záležitost. Po nastavení účtů a
                    dalších záležitostí se toto dialogové okno nebude
                    zobrazovat.
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
            <Bs modalbody>
              <Bs row>
                <Bs col xs={12}>
                  <Bs
                    formcontrol
                    value={this.state.RFID.data}
                    onChange={(e) => {
                      sessionStorage.setItem("RFID", e.target.value);
                      this.setState({
                        RFID: {
                          ...this.state.RFID,
                          data: e.target.value,
                        },
                      });
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        this.setState({
                          RFID: { ...this.state.RFID, open: false },
                        });
                      }
                    }}
                  />
                </Bs>
              </Bs>
            </Bs>
            <Bs modalfooter>
              <Bs row>
                <Bs col xs={12} className="d-flex justify-content-end">
                  <Bs
                    button
                    variant={VARIANT.SUCCESS}
                    size={SIZE.SN}
                    onClick={() =>
                      this.setState({
                        RFID: { ...this.state.RFID, open: false },
                      })
                    }
                  >
                    Autorizovat se
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        )}
        {this.state.newDoc && !this.state.prepare && (
          <NewDocument
            {...this.props}
            prepare={this.state.prepare}
            open={this.state.newDoc}
            card={this.state.card}
            shipDoc={this.state.ship}
            apidata={this.state.apidata}
            apiset={this.usedApiData}
            addDocScan={this.state.scanFile}
            docno={{ DocNo: -1 }}
            resetRFID={() =>
              this.setState({ RFID: { data: null, open: true } })
            }
            close={() => this.setState({ newDoc: false })}
            create={(e) => {
              let ActualDocNo = this.state.docs;
              debugger;
              ActualDocNo.push(e);
              this.setState({ docs: ActualDocNo, newDoc: false });
            }}
          />
        )}
        {this.state.newDoc && this.state.prepare && !this.state.RFID.open && (
          <Unpacking
            {...this.props}
            prepare={this.state.prepare}
            open={this.state.newDoc}
            card={this.state.card}
            shipDoc={this.state.ship}
            apidata={this.state.apidata}
            apiset={this.usedApiData}
            addDocScan={this.state.scanFile}
            docno={{ DocNo: -1 }}
            resetRFID={() =>
              this.setState({ RFID: { data: null, open: true } })
            }
            close={() => this.setState({ newDoc: false })}
            create={(e) => {
              let ActualDocNo = this.state.docs;
              debugger;
              ActualDocNo.push(e);
              this.setState({ docs: ActualDocNo, newDoc: false });
            }}
          />
        )}
        {this.state.existDoc.open && (
          <NewDocument
            {...this.props}
            prepare={this.state.prepare}
            open={this.state.existDoc.open}
            docno={this.state.existDoc.data}
            apidata={this.state.apidata}
            card={this.state.card}
            shipDoc={this.state.ship}
            resetRFID={() =>
              this.setState({ RFID: { data: null, open: true } })
            }
            addDocScan={this.state.scanFile}
            close={() =>
              this.setState({ existDoc: { open: false, data: null, idx: -1 } })
            }
            change={(e) => {
              let ActualDocNo = this.state.docs;
              ActualDocNo.filter((f) => f.DocNo === e.DocNo)[0] = {
                ...ActualDocNo.filter((f) => f.DocNo === e.DocNo)[0],
                ...e,
              };
              this.setState({
                docs: ActualDocNo,
                existDoc: { open: false, data: null },
              });
            }}
          />
        )}
        {this.state.cardDetail && (
          <CardDetail
            {...this.props}
            open={this.state.cardDetail}
            commChanel={this.state.commChanel}
            shipsData={this.state.shipsData}
            prepare={this.state.prepare}
            reset={this.cardReset}
            change={(e) => {
              this.setState(e);
            }}
            setDetail={() =>
              this.setState({
                cardSetDetail: true,
                hideShip: true,
                hideCard: true,
              })
            }
            countriesData={this.state.countriesData}
            close={() => this.setState({ cardDetail: false })}
            cardData={this.state.card}
          />
        )}
        {!this.state.RFID.open && (
          <>
          <Bs row className="mb-2 me-4">
          <Bs col xs={4} className="d-flex">
            {!this.state.prepare && (
              <Bs
                button
                variant={VARIANT.SUCCESS}
                className="me-2"
                size={SIZE.SM}
                onClick={() => this.setState({ scanWebOpen: true })}
              >
                BRTX Karta (Předpříjem)
              </Bs>
            )}
            <Bs
              button
              variant={VARIANT.SUCCESS}
              size={SIZE.SM}
              onClick={() => this.setState({ scanWebOpen: true })}
            >
              Skenovat
            </Bs>
          </Bs>
          <Bs col xs={6} className="d-flex justify-content-end me-4">
            <Bs formtext className="me-4">
              {this.state.prepare
                ? "Přepnout na příjem"
                : "Přepnout na předpříjem"}
            </Bs>
            <Bs
              formswitch
              checked={this.state.prepare}
              onChange={(e) => {
                this.setState({ prepare: e.target.checked });
                localStorage.setItem("type_reception", e.target.checked);
              }}
            />
          </Bs>
        </Bs>
        <Bs row>
          <Bs col xs={12}>
            <Bs col xs={12}>
              <ReceptionSearch
                {...this.props}
                hideShip={this.state.hideShip}
                apidata={(e) => this.apiDataResolver(e)}
                reset={() => window.location.reload()}
                hide={() => this.setState({ hideShip: !this.state.hideShip })}
                set={(e) => {
                  console.log(e);
                  this.setState({ ship: e });
                }}
                stateIdx={this.state}
                setAny={(e) => this.setState(e)}
              />
              {this.state.ship && (
                <Bs row className="mt-4">
                  <Bs col xs={12}>
                    <>
                      {!this.state.card?.CardCode && (
                        <Bs row className="mb-2">
                          <Bs col xs={12}>
                            <Bs inputgroup>
                              <Bs inputgrouptext>Zákazník</Bs>
                              <Bs
                                brtxasyncselect
                                isLoading={this.state.cardsdata}
                                minLength={2}
                                selected={this.state.card.CardCode}
                                promptText="Piš pro vyhledání..."
                                searchText="Hledám požadovaného zákazníka..."
                                emptyLabel="Nic jsem nenašel."
                                onChange={(e) => {
                                  this.setState({
                                    card: { ...this.state.card, ...e[0] },
                                    cardDetail: e.length > 0 ? true : false,
                                  });
                                }}
                                onSearch={this.handleSearch}
                                options={this.state.cardCodes}
                                placeholder="Začni psát"
                                renderMenuItemChildren={(option, props) => (
                                  <Fragment>
                                    <span>{option.label}</span>
                                  </Fragment>
                                )}
                              />
                              <Icon
                                fainfo
                                className="c-gray me-2"
                                data-tip="Začni psát"
                              />
                            </Bs>
                          </Bs>
                        </Bs>
                      )}
                      {this.state.card?.CardCode && (
                        <Bs row>
                          <Bs col xs={12}>
                            <Bs card bg={VARIANT.WHITE}>
                              <Bs cardheader className="bg-white">
                                <Bs row>
                                  <Bs
                                    col
                                    xs={12}
                                    className="d-flex justify-content-between align-items-center"
                                  >
                                    <Bs strong>Zákazník</Bs>
                                    {this.state.hideCard && (
                                      <Icon
                                        fimaximize
                                        data-tip="Zobrazit"
                                        className="c-secondary cursor-pointer"
                                        onClick={() =>
                                          this.setState({
                                            hideCard: !this.state.hideCard,
                                          })
                                        }
                                      />
                                    )}
                                    {!this.state.hideCard && (
                                      <Icon
                                        fiminimize
                                        data-tip="Skrýt"
                                        className="c-secondary cursor-pointer"
                                        onClick={() =>
                                          this.setState({
                                            hideCard: !this.state.hideCard,
                                          })
                                        }
                                      />
                                    )}

                                    <Icon
                                      fatimes
                                      data-tip="Smazat tohoto zákazníka"
                                      className="c-secondary cursor-pointer"
                                      onClick={this.cardReset}
                                    />
                                  </Bs>
                                </Bs>
                              </Bs>
                              {!this.state.hideCard && (
                                <Bs cardbody>
                                  <Bs row>
                                    <Bs
                                      col
                                      xs={1}
                                      className="d-flex justify-content-end align-items-center"
                                    >
                                      {!this.state.cardSetDetail && (
                                        <Icon
                                          aioutlineexclamationcircle
                                          data-tip="<strong>Vyžaduje tvojí pozornost</strong></br></br>Zákazník byl doplněn, ale je třeba to překontrolovat a doplnit chybějící pole"
                                          className="c-danger cursor-help fs-35"
                                        />
                                      )}
                                      {this.state.cardSetDetail && (
                                        <Icon
                                          aioutlinecheckcircle
                                          data-tip="<strong>Vypadá to skvěle!</strong>"
                                          className="c-success cursor-help fs-35"
                                        />
                                      )}
                                    </Bs>
                                    <Bs col xs={7}>
                                      {!this.state.cardSetDetail && (
                                        <Bs row>
                                          <Bs small className="c-danger">
                                            Vyžaduje tvojí pozornost
                                          </Bs>
                                        </Bs>
                                      )}
                                      <Bs row>
                                        <Bs span className="text-muted">
                                          {this.state.card.CardCode}
                                        </Bs>
                                      </Bs>
                                      <Bs row>
                                        <Bs strong className="text-muted">
                                          {this.state.card.CardName}
                                        </Bs>
                                      </Bs>
                                    </Bs>
                                    <Bs col xs={3}>
                                      <Bs row>
                                        <Bs col xs={12}>
                                          <Bs span className="text-muted">
                                            {this.state.card.CardICO}
                                          </Bs>
                                        </Bs>
                                      </Bs>
                                      <Bs row>
                                        <Bs col xs={12}>
                                          <Bs span className="text-muted">
                                            {this.state.card.CardDIC}
                                          </Bs>
                                        </Bs>
                                      </Bs>
                                    </Bs>
                                    <Bs
                                      col
                                      xs={1}
                                      className="d-flex justify-content-end align-items-center"
                                    >
                                      <Icon
                                        faedit
                                        data-tip="Upravit data zákazníka"
                                        className="c-secondary fs-20 cursor-pointer"
                                        onClick={() =>
                                          this.setState({ cardDetail: true })
                                        }
                                      />
                                    </Bs>
                                  </Bs>
                                </Bs>
                              )}
                            </Bs>
                          </Bs>
                        </Bs>
                      )}
                    </>
                  </Bs>
                  {this.state.cardSetDetail && (
                    <>
                      <Bs row>
                        <Bs col xs={12} className="mt-4 mb-4">
                          <Bs row className="mb-2">
                            <Bs formtext>Zařízení</Bs>
                          </Bs>

                          <Bs formtext>
                            Počet zařízení: {this.state.docs.length}
                          </Bs>
                          <Bs
                            card
                            bg={VARIANT.WHITE}
                            className="cursor-pointer"
                            data-tip="Přidat zařízení"
                            onClick={() => this.setState({ newDoc: true })}
                          >
                            <Bs
                              cardbody
                              className="d-flex justify-content-center"
                            >
                              <Bs small className="text-muted me-4">
                                Kliknutím zde přidáš nové zařízení
                              </Bs>
                              <Icon bidevices className="c-secondary fs-20" />
                            </Bs>
                          </Bs>
                        </Bs>
                      </Bs>
                      <Bs row>
                        {this.state.docs.map((e, idx) => (
                          <Bs col xs={12} lg={6} className="mb-2">
                            <Bs card bg={VARIANT.WHITE}>
                              <Bs cardheader className="bg-white">
                                <Bs row>
                                  <Bs col xs={9}>
                                    {e?.DocNo ? (
                                      e.DocNo + " (" + e.NumAtCard + ")"
                                    ) : (
                                      <strong className="c-danger">
                                        NEULOZENA
                                      </strong>
                                    )}
                                  </Bs>
                                  <Bs
                                    col
                                    xs={3}
                                    className="d-flex justify-content-end"
                                  >
                                    <Icon
                                      aioutlinesolution
                                      data-tip="Vytisknout 'Smlouvu o provedení opravy'"
                                      className="c-secondary cursor-pointer me-2 fs-20"
                                    />
                                    <Icon
                                      aioutlineprinter
                                      data-tip="Vytisknout 'Interní štítek'"
                                      className="c-secondary cursor-pointer me-4 fs-20"
                                    />
                                    <Icon
                                      aioutlinefolderopen
                                      data-tip="Otevřít detaily"
                                      className="c-secondary cursor-pointer fs-20"
                                      onClick={() =>
                                        this.setState({
                                          existDoc: {
                                            open: true,
                                            data: e,
                                            idx: idx,
                                          },
                                        })
                                      }
                                    />
                                  </Bs>
                                </Bs>
                              </Bs>
                              <Bs cardbody>
                                <Bs row>
                                  <Bs col xs={4}>
                                    <Bs small>
                                      <Bs strong>{e?.FirmName}</Bs>
                                    </Bs>
                                  </Bs>
                                  <Bs col xs={4}>
                                    <Bs small className="text-muted">
                                      {e?.DeviceSN}
                                    </Bs>
                                  </Bs>
                                  <Bs col xs={4}>
                                    <Bs small className="text-muted">
                                      {new Date(
                                        e?.DatProdej
                                      ).toLocaleDateString()}
                                    </Bs>
                                  </Bs>
                                </Bs>
                                <Bs row>
                                  <Bs col xs={4}>
                                    <Bs small className="text-muted">
                                      {e?.TypeName}
                                    </Bs>
                                  </Bs>
                                  <Bs col xs={4}>
                                    <Bs small className="text-muted">
                                      {e?.ProductCodeSN}
                                    </Bs>
                                  </Bs>
                                  <Bs col xs={4}>
                                    <Bs small className="text-muted">
                                      {new Date(
                                        e?.DatExtPr
                                      ).toLocaleDateString()}
                                    </Bs>
                                  </Bs>
                                </Bs>
                              </Bs>
                            </Bs>
                          </Bs>
                        ))}
                      </Bs>
                    </>
                  )}
                </Bs>
              )}
            </Bs>
          </Bs>
        </Bs>
          </>
        )}
        
      </>
    );
  }
}

export default Reception;
